import React, { useState } from 'react';
import { Select } from '../ui/Select';
import { Input } from '../ui/Input';
export function CreditScoreTab() {
  const [selectedCreditScore, setSelectedCreditScore] = useState('');
  const [minCreditScore, setMinCreditScore] = useState('');
  // Mock data - in real app, this would come from the credit scoring configuration
  const creditScoreOptions = [{
    value: '',
    label: 'Select credit score model...'
  }, {
    value: 'CS-001',
    label: 'CS-001 - Standard Credit Score'
  }, {
    value: 'CS-002',
    label: 'CS-002 - Premium Credit Score'
  }, {
    value: 'CS-003',
    label: 'CS-003 - SME Credit Score'
  }];
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-559">
      <div data-id="element-560">
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-561">
          Credit Scoring Configuration
        </h3>
        <p className="text-sm text-gray-500 mb-6" data-id="element-562">
          Select the credit scoring model to be used for this loan product
        </p>
      </div>

      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-563">
        <div data-id="element-564">
          <Select label="Credit Score Model" value={selectedCreditScore} onChange={e => setSelectedCreditScore(e.target.value)} options={creditScoreOptions} data-id="element-565" />
          <p className="text-xs text-gray-500 mt-1.5" data-id="element-566">
            Select from configured credit scoring models
          </p>
        </div>

        {selectedCreditScore && <div className="pt-4 border-t border-gray-200" data-id="element-567">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200" data-id="element-568">
              <h4 className="text-sm font-semibold text-blue-900 mb-2" data-id="element-569">
                Selected Model Details
              </h4>
              <div className="text-sm text-blue-800 space-y-1" data-id="element-570">
                <div className="flex justify-between" data-id="element-571">
                  <span className="font-medium" data-id="element-572">Credit Score ID:</span>
                  <span data-id="element-573">{selectedCreditScore}</span>
                </div>
                <div className="flex justify-between" data-id="element-574">
                  <span className="font-medium" data-id="element-575">Model Name:</span>
                  <span data-id="element-576">
                    {creditScoreOptions.find(opt => opt.value === selectedCreditScore)?.label.split(' - ')[1]}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-577">
                  <span className="font-medium" data-id="element-578">Total Score Range:</span>
                  <span data-id="element-579">
                    {selectedCreditScore === 'CS-002' ? '1000' : '100'}
                  </span>
                </div>
              </div>
            </div>
          </div>}

        <div data-id="element-580">
          <Input type="number" label="Minimum Credit Score Required" placeholder="e.g. 60" value={minCreditScore} onChange={e => setMinCreditScore(e.target.value)} data-id="element-581" />
          <p className="text-xs text-gray-500 mt-1.5" data-id="element-582">
            Minimum score required for loan approval (based on selected model's
            range)
          </p>
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-583">
        <h4 className="text-sm font-medium text-gray-900 mb-3" data-id="element-584">
          Credit Scoring Information
        </h4>
        <div className="space-y-2 text-sm text-gray-600" data-id="element-585">
          <div className="flex items-start" data-id="element-586">
            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-587"></span>
            <span data-id="element-588">
              <strong data-id="element-589">Credit Score Model:</strong> The scoring model defines how
              applicant creditworthiness is calculated
            </span>
          </div>
          <div className="flex items-start" data-id="element-590">
            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-591"></span>
            <span data-id="element-592">
              <strong data-id="element-593">Minimum Score:</strong> Applications below this threshold
              will be automatically rejected
            </span>
          </div>
          <div className="flex items-start" data-id="element-594">
            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-595"></span>
            <span data-id="element-596">
              <strong data-id="element-597">Score Range:</strong> Different models may use different
              scoring ranges (100 or 1000)
            </span>
          </div>
        </div>
      </div>
    </div>;
}